import { useUnsavedChanges } from "aic";
import { BottomNav } from "components/topbar/BottomNav";
import { AppSettingsContext } from "contexts/AppSettingsContext";
import { useContext, useEffect } from "react";
import { Col, Container, NavDropdown, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import ErrorBoundary from "../components/common/ErrorBoundary";
import { News } from "../components/frontpage/News";
import { Search } from "../components/frontpage/Search";
import { HierarchyLinks } from "../components/hierarchypage/HierarchyLinks";
import { TopBar } from "../components/topbar/TopBar";
import { eApplicationPermission } from "../functions/api/enums";
import { downloadStats } from "../functions/api/tlfItem/downloadStats";
import { useDocumentTitle } from "../functions/useDocumentTitle";

/**
 * The landing page
 */
export const StartPage = (): React.ReactElement => {
  const appSettings = useContext(AppSettingsContext);
  useDocumentTitle("Home page");

  const { clearUnsavedChanges } = useUnsavedChanges("start-page");
  useEffect(() => {
    clearUnsavedChanges();
  }, [clearUnsavedChanges]);

  return (
    <ErrorBoundary>
      <TopBar
        title="MOSAIC Biometrics"
        fileEntry={
          <>
            <NavDropdown.Item
              id="topbar-load-link"
              as={Link}
              to="/Corporate/Load"
            >
              Load TLF
            </NavDropdown.Item>
            {appSettings.applicationPermissions.includes(
              eApplicationPermission.AllowJsonDownload,
            ) && (
              <>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  onClick={() => {
                    downloadStats(appSettings.backEndUrl);
                  }}
                >
                  Download JSON statistics data
                </NavDropdown.Item>
              </>
            )}
          </>
        }
      />
      <Container fluid>
        <Row>
          <Col
            id="start-page-lhs"
            xs={2}
            className="small-scrollbar col-between-top-and-bottom"
          >
            <HierarchyLinks />
          </Col>
          <Col
            id="start-page-rhs"
            xs={10}
            className="position-relative d-flex flex-column col-between-top-and-bottom"
          >
            <Row className="small-scrollbar">
              <Search />
              <News />
            </Row>
          </Col>
        </Row>
      </Container>
      <BottomNav />
    </ErrorBoundary>
  );
};

StartPage.displayName = "StartPage";

export default StartPage;
